export const LongLatPattern = /^([-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)),\s*([-+]?(180(\.0+)?|((1[0-7]\d)|(\d{1,2}))(\.\d+)?))$/;
export const AlphaNumericPattern = /^[A-Za-z0-9]+$/;
